import { createSlice } from '@reduxjs/toolkit';
const initialAuthState = {
  isLoading: false,
  isAuthenticated: false,
  token: null,
  user: {},
  loggedInUser: {},
  missionDetails: {
    quickLinks: []
  },
  userThumbnail: {},
  profileConfig: {
    showProfile: false,
    showProfileForm: false,
    scrollToCoupon: false,
    profileFormPage: 0,
    userId: 0,
    offeringUserId: 0,
    profileData: {},
    refreshProfile: 0,
    profileStack: [],
    showLoader: false,
    offeringId: 0
  },
  tokenData: {},
  userPoints: {},
  messagePoint: {
    offeringId: 0,
    offeringUserId: 0,
    teamId: 0,
    connectionId: "",
    actionKey: 0,
    activityId: 0
  },
  updateCoachStats: false,
  updateProfileImage: false,
  coachStatsData: {},
  coachOnlyActivities: [],
  userTeams:[]
};

const authSlice = createSlice({
  name: 'authentication',
  initialState: initialAuthState,
  reducers: {
    login(state, action) {
      state.isAuthenticated = true;
      state.isLoading = false;
      state.loggedInUser = action.payload;
      state.userThumbnail = { firstName: action.payload.firstName, lastName: action.payload.lastName, profileImage: action.payload.profileImage };
      state.messagePoint = {
        offeringId: action.payload.offeringId,
        offeringUserId: action.payload.offeringUserId,
        teamId: action.payload.teamId,
        actionKey: 0,
        activityId: 0
      };
    },

    logout(state) {
      state.isAuthenticated = false;
      state.isLoading = false;
    },
    setLoggedInUser(state, action) {
      state.loggedInUser = action.payload;
      state.isLoading = false;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    setMissionDetails(state, action) {
      let temp = { ...action.payload };
      let tempObj = { ...action.payload };

      tempObj.tasks = [];

      tempObj.tasks = temp.tasks.filter(x => x.activityTypeId != 6).sort((a, b) => a.sequence > b.sequence ? 1 : -1);

      state.coachOnlyActivities = [...temp.tasks.filter(x => x.activityTypeId == 6).sort((a, b) => a.sequence > b.sequence ? 1 : -1).map(item => { return { ...item, isComplete: true }; })];
      state.missionDetails = tempObj;
    },

    setPoints(state, action) {
      state.loggedInUser = { ...state.loggedInUser, ...action.payload };
      state.userPoints = { ...action.payload };
    },
    setProfileData(state, action) {
      state.profileConfig.userId = action.payload.userId;
      state.profileConfig.offeringUserId = action.payload.offeringUserId;
      if (action.payload.offeringId) {
        state.profileConfig.offeringId = action.payload.offeringId;
      }
    },
    setProfileLoader(state, action) {
      state.profileConfig.showLoader = action.payload.showLoader;
    },
    setProfileStack(state, action) {
      var test = state.profileConfig.profileStack ? state.profileConfig.profileStack : [];
      let temp = [...test];
      temp.push({ userId: action.payload.userId, offeringUserId: action.payload.offeringUserId });
      state.profileConfig.profileStack = temp;
    },
    UpdateProfileStack(state, action) {
      let temp = [...state.profileConfig.profileStack];
      temp.pop();
      state.profileConfig.profileStack = temp;
    },
    setUserProfileData(state, action) {
      state.profileConfig.profileData = action.payload;
    },
    showProfile(state, action) {
      state.profileConfig.showProfile = true;
      state.profileConfig.scrollToCoupon = action.payload && action.payload.scrollToCoupon ? true : false;
    },
    setTokenData(state, action) {
      // debugger;

      sessionStorage.setItem("cdx-token", JSON.stringify(action.payload));
      state.tokenData = action.payload;
    },
    hideProfile(state, action) {
      state.profileConfig.profileStack = [];
      state.profileConfig.showProfile = false;
    },
    showProfileForm(state, action) {
      state.profileConfig.showProfileForm = true;
      state.profileConfig.profileFormPage = action.payload;
    },
    hideProfileForm(state, action) {
      state.profileConfig.showProfileForm = false;
      state.profileConfig.profileFormPage = 0;
    },
    previousPage(state, action) {
      state.profileConfig.profileFormPage = state.profileConfig.profileFormPage <= 1 ? 1 : state.profileConfig.profileFormPage - 1;
    },
    nextPage(state, action) {
      state.profileConfig.profileFormPage = state.profileConfig.profileFormPage >= 3 ? 3 : state.profileConfig.profileFormPage + 1;
    },
    refreshProfile(state, action) {
      state.profileConfig.refreshProfile = state.profileConfig.refreshProfile + 1;
    },
    setOverviewVisited(state) {
      state.loggedInUser.overviewVisited = true;
    },
    setPointTypes(state, action) {
      state.pointTypes = action.payload;
    },
    setConnectionId(state, action) {
      state.messagePoint.connectionId = action.payload;
    },
    setCoachStats(state, action) {
      state.updateCoachStats = !state.updateCoachStats;
    },
    setProfilePage(state, action) {
      state.profileConfig.profileFormPage = action.payload;
    },
    setProfileImage(state, action) {
      state.updateProfileImage = !state.updateProfileImage;
      state.loggedInUser.profileImage = action.payload;
    },
    setSolutionId(state, action) {
      state.loggedInUser.solutionId = action.payload;
    },
    setCoachStatsData(state, action) {
      state.coachStatsData = action.payload;
    },
    setCurrentOfferingId(state, action) {
      state.loggedInUser.offeringId = action.payload;
    },
    setTourCompleted(state) {
      state.loggedInUser.tourCompleted = true;
    },
    setUserTeams(state, action) {
      state.userTeams = action.payload;
    },
  },
});

export default authSlice;